'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import type { LecturerCard } from '@eliadmin/core/src/api/courses/coursers-api';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

export function LectorCard({ lecturer }: { lecturer: LecturerCard }) {
  const { t } = useTranslations();

  return (
    <Link
      prefetch={false}
      prefetchOnHover
      href={lecturer.slug}
      className="flex w-full flex-col items-start justify-start gap-4 sm:gap-5 lg:gap-6"
    >
      <Image
        src={lecturer?.image?.url ?? '/images/placeholder.png'}
        alt={resolveImageAlt(lecturer?.image, lecturer?.name)}
        width={0}
        height={0}
        className="aspect-square w-full object-cover object-center"
        sizes="295px"
      />
      <div className="flex flex-col items-start justify-start gap-0">
        <h3 className="line-clamp-1 pb-1 font-heading text-sm font-bold text-white sm:pb-2 sm:text-base md:text-lg lg:text-xl xl:text-2xl">
          {lecturer.name}
        </h3>
        {lecturer.categories && lecturer.categories.length > 0 ? (
          <p className="text-xs font-normal text-white/70 sm:text-sm lg:text-base">
            {lecturer.categories.map((category, index) => (
              <span key={category.id}>
                {category.name}
                {index < (lecturer?.categories?.length ?? 0) - 1 && ', '}
              </span>
            ))}
          </p>
        ) : (
          <div className="invisible h-[17px] w-10 sm:h-[19px] lg:h-[22px]" />
        )}
      </div>
      <p className="text-sm font-bold text-white underline md:text-base">{t('text2415')}</p>
    </Link>
  );
}
